var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16851_63625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.95844 16.4272V5.30219L5.375 8.88531L3.89594 7.38531L10 1.28125L16.1041 7.38531L14.625 8.88531L11.0416 5.30219V16.4272H8.95844ZM2.08344 21.2812C1.52094 21.2812 1.03302 21.0747 0.619688 20.6616C0.206563 20.2482 0 19.7603 0 19.1978V14.9688H2.08344V19.1978H17.9166V14.9688H20V19.1978C20 19.7603 19.7934 20.2482 19.3803 20.6616C18.967 21.0747 18.4791 21.2812 17.9166 21.2812H2.08344Z",
    fill: "#A50DFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16851_63625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/Upload-File.47359329bdf5db0c60ab062832efc34c.svg";
export { ForwardRef as ReactComponent };